import React, { useEffect, useState } from "react"

import './Contact.css'
import { ContactsPage } from "@/env/contact"
import { Translates } from "@/services/repository/i18n"

interface Props {
  translates: Translates,
  contacts: ContactsPage
}

interface Image {
  url: string
}

export const ContactBox: React.FC<Props> = ({
  translates,
  contacts
}) => {

  return <div className="contacts-container">
    {contacts.persons.map((row) => <div className="person">
      {row.pictureURL ? <img className='face' src={row.pictureURL} /> : null}
      <div className='name'>{row.name}</div>
      <div className='role'>{row.role}</div>
      <div className='email'>{row.email}</div>
      <div className='phone'>{row.phone.label}</div>

      <div className='btns'>
        <a className='main-green-btn' href={`tel:${row.phone.value}`}>
          {translates.forDevice('menu.callMe')?.replace('{phone}', row.phone.label)}
        </a>
      </div>
    </div>)}
    {contacts.companies.map((row) => <div className="company">
      {row.pictureURL ? <img className='picture' src={row.pictureURL} /> : null}
      <div className='name'>{row.name}</div>
      <div className='street'>{row.street}</div>
      <div className='city'>{row.city}</div>
      <div className='country'>{row.country}</div>
      <div className='nip'>NIP: {row.nip}</div>
      <div className='website'><a target="_blank" href={`http://${row.website}`}>{row.website}</a></div>
      <div className='email'><a href={`mailto:${row.email}`}>{row.email}</a></div>
      <div className='phone'><a href={`tel:${row.phone.value}`}>{row.phone.label}</a></div>

      <div className='btns'>
        <a className='main-green-btn' href={`tel:${row.phone.value}`}>
          {translates.forDevice('menu.callMe')?.replace('{phone}', row.phone.label)}
        </a>
      </div>
    </div>)}
  </div>
}